export default __webpack_public_path__ + "static/media/screenBlock13.6431fa6c.jpg";